import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
export const DefaultRouter = ({ children, publicPath }) => {
    return React.createElement(BrowserRouter, { basename: publicPath }, children);
};
DefaultRouter.displayName = 'DefaultRouter';
//# sourceMappingURL=DefaultRouter_v5.js.map